/* eslint-disable no-param-reassign */
import { components } from "react-select";
import PropTypes from "prop-types";

const MultiValueLabel = ({ className, preserveStyle, children, ...otherProps }) => {
  if (!preserveStyle) {
    // So that the default styles aren't applied, for full customization
    otherProps.getStyles = () => ({});
  }

  return (
    <components.MultiValueLabel {...otherProps} className={className}>
      {children}
    </components.MultiValueLabel>
  );
};

MultiValueLabel.propTypes = {
  className: PropTypes.string,
  preserveStyle: PropTypes.bool,
  children: PropTypes.node,
};

MultiValueLabel.defaultProps = {
  className: "",
  preserveStyle: false,
  children: null,
};

export default MultiValueLabel;
